module.exports = __webpack_public_path__ + "static/media/verkoopsakte_right_page.8c191760.jpg";